import { render, staticRenderFns } from "./menuDesignLeft.vue?vue&type=template&id=351289fe&scoped=true"
import script from "./menuDesignLeft.vue?vue&type=script&lang=js"
export * from "./menuDesignLeft.vue?vue&type=script&lang=js"
import style0 from "./menuDesignLeft.vue?vue&type=style&index=0&id=351289fe&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351289fe",
  null
  
)

export default component.exports